<template>
  <Navbar />
</template>
<script>
import Navbar from "@/components/AllNavBar.vue";
import store from "@/store";
export default {
  components: { Navbar },
  data() {
    return {
      r2: JSON.parse(store.state.randp.r2).create,
    };
  },
  async mounted() {
    if (this.r2 != true) {
      this.$root.$router.push({
        path: "/SignIn",
      });
    }
  },

  methods: {},
  watch: {},
};
</script>